export default "/react/marketolog-pro-6674c5bd.svg";